import Cookie from 'js-cookie';

import { Config } from '@nw/shared/config';

import {
  getCookie,
  getCookieAttrubutes,
  setCookie
} from '../AccountsStorageUtils';

const FORMS_ACCESS_TOKEN_KEY = 'n67h8d7edq';
const FORMS_REFRESH_TOKEN_KEY = 'nsgor39syl';

export function getFormsAccessToken() {
  return getCookie(FORMS_ACCESS_TOKEN_KEY);
}

export function getFormsRefreshToken() {
  return getCookie(FORMS_REFRESH_TOKEN_KEY);
}

export function setFormsAccessTokenToDomain(
  accessToken: string,
  expiryInDays = 30
) {
  setCookie(
    FORMS_ACCESS_TOKEN_KEY,
    accessToken,
    expiryInDays,
    Config['APP_AUTH_COOKIE_DOMAIN']
  );
}

export function setFormsRefreshTokenToDomain(
  refreshToken: string,
  expiryInDays = 30
) {
  setCookie(
    FORMS_REFRESH_TOKEN_KEY,
    refreshToken,
    expiryInDays,
    Config['APP_AUTH_COOKIE_DOMAIN']
  );
}

export const clearFormsAccessToken = () => {
  Cookie.remove(FORMS_ACCESS_TOKEN_KEY, {
    path: '/',
    secure: true,
    sameSite: 'None'
  });
};

const clearFormsDomainAccessToken = (domain?: string) => {
  Cookie.remove(FORMS_ACCESS_TOKEN_KEY, {
    ...getCookieAttrubutes(),
    domain: domain
  });
};

const clearFormsDomainRefreshAccessToken = (domain?: string) => {
  Cookie.remove(FORMS_REFRESH_TOKEN_KEY, {
    ...getCookieAttrubutes(),
    domain: domain
  });
};

export const clearFormsDomainTokens = () => {
  const appCookieDomain =
    Config['APP_COOKIE_DOMAIN'] || Config['APP_AUTH_COOKIE_DOMAIN'];
  if (appCookieDomain) {
    clearFormsDomainAccessToken(appCookieDomain);
    clearFormsDomainRefreshAccessToken(appCookieDomain);
  }
};

export const clearFormsRefreshAccessToken = () => {
  Cookie.remove(FORMS_ACCESS_TOKEN_KEY, {
    path: '/',
    secure: true,
    sameSite: 'None'
  });
};
